import styled, { css } from 'styled-components';

const media = {
  handheld: (...args) => css`
    @media (max-width: 768px) {
      ${ css(...args) }
    }
  `
}

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 16px;
`

export const FormContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
  padding: 8px 16px;
  padding-top: 48px;
`

export const FormGroup = styled.div`
  padding: 16px 8px;
  position: relative;
`

export const FormTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
`


export const Pre = styled.pre`
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  max-height: 500px;
  background-color: #333;
  border-radius: 4px
`

export const Code = styled.code`
  color: #F44336;
  display: block;
  overflow: hidden;
  padding: 16px;
  line-height: 1.35;
`

export const NavOuter = styled.div`
  background-color: ${props => props.bg};
`
export const NavContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;



export const styles = {
  uploadButton: {
    verticalAlign: 'middle',
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
};




// pagination style page
export const Header = styled.div`
  display: flex;
  align-items: center;
  ${ media.handheld`
    flex-direction: column;
    align-items: flex-start
  `}
`

export const UsersTableContainer = styled.div`
  padding: 8px 0;
  width: 100%;
  overflow-x: auto;
`
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
`
export const PageStateContainer = styled.div`
  flex: 1;
  ${ media.handheld`
    margin-bottom: 16px
  `}
`
export const PageState = styled.span`
  line-height: 36px;
  padding: 0 8px;
`
 


export const SubTitle = styled.h2`
  font-size: 18px;
  text-align: ${props => props.center ? 'center': 'left'};
  text-transform: uppercase;
  font-weight: 600;
  padding-bottom: 16px
`

export const ChartContainer = styled.div`
  position: relative;
  ${props => props.divider && 
    `&:after {
      content: '';
      position: absolute;
      width: 1px;
      top: 25%;
      left: 0;
      height: 50%;
      background: #19857b
    }`
  }
`

export const text16 = {
  fontSize: '16px'
}



// WEBPACK FOOTER //
// ./src/components/Styles/index.js